import React, { useEffect, useState } from 'react';
import { Tree, Switch } from 'antd';
import { addFile, getAvList, showFileContent } from 'api/api_service';
import { IFileDetails } from 'types';
import strings from '../../strings/strings.json'
import { useHistory } from 'react-router-dom';
import PathModal from './path_modal';
import { IAntiviruses } from 'types';
import moment from 'moment-jalaali';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { antiNameHandler } from 'module/anti_name_handler';
import Layout from 'components/layout';

export default function ChooseFile() {
    const [treeData, setTreeData] = useState<Array<IFileDetails>>([]);
    const [selectedFileData, setSelectedFileData] = useState<Array<string>>([]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [avList, setAvList] = useState<Array<IAntiviruses>>([])
    const [setlectedAvsStatus, setSelectedAvsStatus] = useState<Array<string>>([])
    const history = useHistory()
    const dispatch = useDispatch();

    let arrayData: Array<IFileDetails> = []

    useEffect(() => {
        showFileContentHandler('')
        getAvList()
            .then(res => {
                if (res.status === 200) {
                    setAvList(res.data.data)
                }
            })

    }, [])


    let loadData: Array<object> = []
    const mapData = (data: any) => {
        if (loadData.length === 0 && data) {
            data.map((data: any, index: number) => {
                loadData.push({
                    key: data.path,
                    title: data.path,
                    isLeaf: data.is_file,
                })
            })
        }
        return loadData
    }

    const onLoadData = ({ key, children }: any) =>
        new Promise<void>(async resolve => {
            if (children) {
                resolve();
                return;
            }
            await showFileContent({
                "path": key
            })
                .then(res => {
                    if (res.status === 200) {
                        setTreeData(origin =>
                            updateTreeData(origin, key, mapData(res.data.data))
                        )
                    }
                    resolve()
                })
        });

    function updateTreeData(list: any, key: React.Key, children: any): any[] {
        return list.map((node: { key: React.Key; children: any; }) => {
            if (node.key === key) {
                return {
                    ...node,
                    children,
                };
            }
            if (node.children) {
                return {
                    ...node,
                    children: updateTreeData(node.children, key, children),
                };
            }
            return node;
        });
    }

    const onCheck = (checkedKeys: any, info: any) => {
        if (!selectedFileData.find((o: any) => o === info.node.title)) {
            let data = selectedFileData.concat(info.node.title)
            setSelectedFileData(data)
        } else {
            let index = selectedFileData.indexOf(info.node.title);
            if (index > -1) {
                selectedFileData.splice(index, 1)
            }
        }
    }

    const avActiveStatusHandler = (isSelected: any, data: any) => {
        setAvList((prevState: any) => {
            return prevState.map((el: any) => {
                if (el.name === data.name) {
                    el.enabled = isSelected
                    return {
                        ...el,
                        el
                    }
                } else {
                    return el
                }
            })
        })
    }
    const mapHandler = (data: any, index: number) => {
        return (
            <div key={index} className={`flex justify-between px-1 py-2 ${index + 1 !== avList.length ? ' border-b border-b-gray-200 ' : ''}`}>
                <div className='flex items-center'>
                    <div>{data.name !== undefined && <img className='w-6 h-6' src={require(`../../assets/icons/${data.name}.png`)} alt="Icon" />}</div>
                    <div className='flex flex-col mr-2'>
                        <span className='primary_text_color text-sm VazirEng'>{data.name !== undefined && antiNameHandler(data.name)}</span>
                        <span className='text-xs secondry_text_color'><span>{strings.public_lastVersion}: {data.version ? moment(data.version).format("jYYYY/jM/jD") : 'ندارد'}</span></span>
                    </div>
                </div>
                <div className='flex items-center'>
                    <Switch disabled={data.version ? false : true} checked={data.enabled} onChange={(e) => avActiveStatusHandler(e, data)} />
                </div>
            </div >
        )
    }

    const showFileContentHandler = (path: string) => {
        showFileContent(path ? { "path": path } : {})
            .then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        res.data.data.map((data: any, index: number) => {
                            arrayData.push({
                                key: data.path,
                                title: data.path,
                                isLeaf: data.is_file
                            })
                        })
                        setTreeData(arrayData)
                    }
                }
            })
    }

    const confirmPathFile = (path: string) => {
        showFileContentHandler(path)
        setOpenModal(false)
    }

    const confirmHandler = () => {
        let selectedAvs: Array<string> = []
        avList.forEach((av, i) => {
            if (av.enabled)
                selectedAvs.push(av.name)
        });


        let avPermission: boolean = false
        let filePermission: boolean = false
        if (selectedAvs.length === 0) {
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.selectFile_errorAv}` }));
            avPermission = false
        } else {
            avPermission = true
        }
        if (selectedFileData.length === 0) {
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.selectFile_errorFile}` }));
            filePermission = false
        } else {
            filePermission = true
        }
        if (avPermission && filePermission) {
            history.push({
                pathname: '/docker',
                state: [selectedAvs, selectedFileData] // your data array of objects
            })
        }
    }

    return (
        <Layout>
            <div dir='rtl' className='w-full px-10'>
                <div className='flex h-full flex-col'>
                    <div className='h-14 flex justify-between items-center'>
                        <span className='primary_text_color font-bold text-lg'>{strings.selectFile_chooseFileAndAvs}</span>
                    </div>
                    <div className='flex-1 grid grid-cols-2'>
                        <div>
                            <div className={`h-96 overflow-y-scroll border border-gray-200 rounded-lg m-5 px-3`}>
                                {avList.length !== 0 && avList.map(mapHandler)}
                            </div>
                        </div>
                        <div>
                            <div dir="ltr" className='flex justify-start h-96 overflow-y-scroll border border-gray-200 rounded-lg m-5 px-1 py-2'>

                                {
                                    (treeData !== undefined && treeData.length !== 0) ?
                                        <Tree
                                            className='text-green-300 VazirEng'
                                            loadData={onLoadData}
                                            autoExpandParent={false}
                                            treeData={treeData}
                                            checkable
                                            onCheck={onCheck}
                                            showLine={true}
                                        />
                                        :
                                        <div className='flex justify-center w-full items-center'>{strings.public_noData}</div>
                                }
                            </div>
                        </div>

                    </div>
                    <div className='flex h-20 py-5 justify-between'>
                        <button className='rounded-full border border-black px-10 py-3' onClick={() => history.goBack()}>{strings.public_back}</button>
                        <button className='text-white rounded-full px-10 py-3 primary_bg_color' onClick={() => confirmHandler()}>{strings.public_continue}</button>
                    </div>
                    <PathModal
                        confirmClicked={(path) => confirmPathFile(path)}
                        onCloseModal={() => setOpenModal(false)}
                        openModal={openModal}
                    />
                </div>
            </div>
        </Layout>

    )
}
